<template>
  <div class="footer">
    <div class="nav-box">
      <div class="footer-nav" v-for="(item, index) in menusList" :key="index" @click="test(item.path,index)">
        <div class="nav-one" :class="navIndex === index? 'avtive': ''">
          <div class="img-box pointer">
            <img :src="navIndex === index? item.activeSrc:item.src" />
          </div>
          <div class="pointer">{{item.displayName}}</div>
        </div>
      </div>
    </div>
    <!-- <el-menu
      :default-active="activeIndex"
      class="page-header-menu"
      mode="horizontal"
      @select="handleMenuItemSelect"
    >
      <el-menu-item v-for="item in menus" :key="item.name" :index="item.name">
        <template slot="title">
          <i class="el-icon-location"></i>
        </template>
        {{ item.displayName }}
      </el-menu-item>
    </el-menu>-->
    <div class="title">技术支持：深圳华云声信息技术有限公司</div>
  </div>
</template>
<script>
import menus from './menus';
import projectMenus from './project-menus';
import { queryHouseholdIndex } from '@/api/publicinquiry.api.js';
import { getSession } from '@/untils';
export default {
  name: 'Foooter',
  data() {
    return {
      menusList: [],
      menus,
      projectMenus,
      navIndex: 0,
      token: '',
      sessionId: '',
      projectId: '',
      path: ''
    };
  },
  methods: {
    test(path, index) {
      this.token = getSession('token');
      this.sessionId = getSession('session');
      this.projectId = getSession('projectId');
      if (path === '/personal' || path === '/selection') {
        if (this.token !== 'undefined' && this.sessionId !== 'undefined') {
          queryHouseholdIndex(this.projectId).then(res => {
            if (res.code === 0) {
              if (path === '/personal') {
                this.path = '/personaldetail';
              } else {
                this.path = '/selectionDetail';
              }
              if (this.path === '/personaldetail') {
                this.navIndex = 5;
              } else {
                this.navIndex = 4;
              }
              this.$router.push({ path: this.path });
            } else if (res.code === 5 || res.code === 7) {
              this.$router.push({ path: path });
            }
          });
        } else {
          this.$router.push({ path: path });
        }
      } else {
        this.$router.push({ path: path });
      }
    },
    checkRouterLocal(path) {
      let that = this;
      if (
        path === '/public' ||
        path === '/news' ||
        path === '/news/detail' ||
        path === '/incident' ||
        path === '/incident/detail' ||
        path === '/theme' ||
        path === '/theme/themeDetail' ||
        path === '/articles' ||
        path === '/articles/articlesDetail' ||
        path === '/projectlist'
      ) {
        this.menusList = this.menus;
      } else {
        let projectMenus = this.projectMenus;
        if (getSession('personalSwitch') == 0) {
          projectMenus = projectMenus.filter(item => item.name !== 'personal');
        }
        if (getSession('houseType') == 1) {
          projectMenus = projectMenus.filter(item => item.name !== 'selection');
        } else {
          projectMenus = projectMenus.filter(item => item.name !== 'xian');
        }
        this.menusList = projectMenus;
      }
      if (path === '/projectlist') {
        this.navIndex = 0;
      }
      // this.navIndex = this.navList.findIndex(item => item.path === path);
      this.menusList.forEach(function (item, index) {
        if (item.path.indexOf(path) != -1) {
          that.navIndex = index;
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      let path = this.$route.path;
      let name = this.$route.name;
      this.checkRouterLocal(path);
    }
  },
  mounted() {
    let path = this.$route.path;
    this.checkRouterLocal(path);
  },
  created() {
    this.projectId = getSession('projectId');
  }
};
</script>
<style scoped>
.footer {
  min-width: 1000px;
  width: 90%;
  /* position: absolute;
  bottom: 0;
  left: 0;
  right: 0; */
  margin: auto;
}
/* .el-menu--horizontal > .el-menu-item.is-active,
.el-menu--horizontal > .el-menu-item {
  border-bottom: none !important;
  padding: 0px 90px;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: rgb(224, 245, 255);
} */
.title {
  font-size: 16px;
  line-height: 60px;
  color: #ffffff;
  text-align: center;
}
.nav-box {
  display: flex;
  /* width: 1200px; */
  background: #ffffff;
  flex-wrap: nowrap;
  justify-content: space-around;
  box-sizing: border-box;
  margin-top: 10px;
}
.footer-nav {
  background: #ffffff;
}
.footer-nav-new {
  padding: 0 59px;
}
.nav-one {
  padding: 10px 0px;
  font-size: 15px;
  vertical-align: middle;
  display: table-cell;
  text-align: center;
  width: 80px;
}
.nav-one img {
  width: 44px;
}
.router-link-active {
  color: #025b91;
}
.img-box {
  text-align: center;
}
.avtive {
  color: #025b91;
  font-weight: 700;
  background: rgb(224, 245, 255);
}
.pointer {
  cursor: pointer;
}
.nav-one:hover {
  background: rgb(224, 245, 255);
}
.footer-padding {
  padding: 0 60px;
}
</style>



// WEBPACK FOOTER //
// src/layout/footer.vue